'use client';

import { ApiReferenceReact } from '@scalar/api-reference-react';
import '@scalar/api-reference-react/style.css';
import { useTheme } from 'next-themes';

export function ApisContent() {
  const { resolvedTheme } = useTheme();

  return (
    <div
      className="scalar-wrapper"
      style={{
        ['--scalar-custom-header-height' as string]:
          'var(--header-height, 64px)',
      }}
    >
      <ApiReferenceReact
        configuration={{
          url: '/api/openapi.json',
          documentDownloadType: 'none',
          withDefaultFonts: false,
          persistAuth: true,
          defaultOpenAllTags: true,
          expandAllResponses: false,
          expandAllModelSections: false,
          hideModels: true,
          hiddenClients: true,
          hideClientButton: true,
          darkMode: resolvedTheme === 'dark',
          hideDarkModeToggle: true,
        }}
      />
    </div>
  );
}
